import { Layout, Space, Typography, Image, Flex, Input, Button } from "antd";
import styled from "styled-components";

export const ProgramSingleTrainingLayout = styled(Layout)`
  background-color: transparent;
  padding-top: 0;
`;

export const StyledTraningPartWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;
`;

export const TraningPartSelectWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})`
  display: flex;
  gap: 1rem;
`;

export const TraningPartsWrapper = styled(Space).attrs({
  direction: "vertical",
})`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const TraningExercisesWrapper = styled(Space).attrs({
  direction: "vertical",
  size: 20,
})`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 13.125rem;
  /* min-width: 40rem; */
  padding: 15px 18px 15px 18px;
  gap: 5px;
  border-radius: 8px 8px 8px 8px;
  border: 1px 1px 1px 1px;
  background-color: #f8f8f847;
  border: 1px solid #f1f1f1;
`;

export const ExerciseDragDropTitle = styled(Typography.Text)`
  font-size: 14px;
  font-weight: 400;
  color: black;
`;

export const ExerciseDragDropLabel = styled(Typography.Text)`
  font-size: 14px;
  color: #808080;
`;

export const StyledAddPart = styled(Flex)`
  cursor: pointer;
  width: fit-content;
  margin: 10px auto;
`;

export const ProgramSingleTrainingSider = styled(Layout.Sider)`
  background-color: #fdfdfd;
  border-right: 1px solid #f1f1f1;
`;

export const ExerciseSiderCardsWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  max-height: 65vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5f5df0;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const ExerciseSiderSearch = styled(Input.Search).attrs({
  allowClear: true,
  direction: "rtl",
})`
  width: 100%;
  padding: 1rem;
  text-align: right;
  height: 64px;

  .ant-input-prefix {
    margin-left: 10px;
  }
  .ant-input-group-addon {
    display: none;
  }
`;

export const ExerciseSiderCard = styled(Flex)`
  padding: 0.5rem;
  background-color: #f8f8f847;
  width: 100%;
  height: 5rem;
  gap: 2rem;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #f1f1f1;
`;

export const ExerciseSiderCardImage = styled(Image).attrs({
  preview: false,
  style: {
    width: "4rem",
    height: "4rem",
    objectFit: "cover",
  },
})``;

export const ExerciseSiderCardDetails = styled(Space).attrs({
  direction: "vertical",
  size: "small",
})`
  display: flex;
  flex-direction: column;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ExerciseSiderCardTitle = styled(Typography.Text)`
  font-size: 14px;
  font-weight: 500;
  color: black;
`;

export const ExerciseSiderCardDescription = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 400;
  width: 100%;
  color: #808080;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 95%;
  display: inline-block;
`;

export const ExerciseCard = styled(Flex)<{ isEditable: boolean }>`
  display: flex;
  flex-direction: row;
  background-color: white;
  border: 1px solid #f1f1f1;
  padding: 0.5rem;
  gap: 1rem;
  cursor: move;
  pointer-events: ${(props) => (props.isEditable ? "auto" : "none")};
`;

export const ExerciseCardRightContainer = styled(Space).attrs({
  direction: "horizontal",
  size: "small",
})`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  max-width: 100%;
  max-height: 100%;
`;

export const ExerciseCardImage = styled(Image).attrs({
  preview: false,
  style: {
    width: "9.125rem",
    height: "5.875rem",
    objectFit: "contain",
  },
})``;

export const ExerciseCardLeftContainer = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ExerciseCardRowWrapper = styled(Space).attrs({
  direction: "horizontal",
  size: "small",
})`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const StyledRemoveButton = styled(Button).attrs({
  type: "text",
})`
  padding: 0;
  background-color: transparent;
  border: none;
  color: #313131;
  font-weight: 400;
  font-size: 14px;
`;

export const StyledTraningPartsWrapper = styled(Space).attrs<{
  isEditable: boolean;
}>({
  direction: "vertical",
  size: "middle",
})`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  /* max-height: 60vh; */
  overflow-y: auto;
  padding-left: 1rem;
  max-height: ${(props) => (props.isEditable ? "65vh" : "unset")};

  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5f5df0;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const StyledPartInputWrapper = styled(Flex)`
  min-width: 220px;
`;
